import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const Title = styled.h3`
    display: flex;
    margin-top: 15px;
    margin-bottom: 60px;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 24px;
    color: #272525;
    font-weight: 800;
    font-size: 34px;
    line-height: 50px;
    letter-spacing: -1px;

    ${device.tablet} {
        display: block;
        zoom: 1.15;
        margin-top: 25px;
        padding-bottom: 5px;
        margin-bottom: 20px;
    }

    ${device.mobile} {
        display: block;
        font-size: 25px;
        margin-bottom: 20px;
        line-height: 32px;
        padding-bottom: 5px;
    }

`;

const Desc = styled.span`
    padding-left: 26px;
    font-size: 18px;
    color: #707070;
    font-weight: 400;
    letter-spacing: -0.4px;

    ${device.tablet} {
        display: block;
        padding-left: 0;
    }
    ${device.mobile} {
        display: block;
        padding-left: 0;
        font-size: 14px;
        letter-spacing: -0.5px;
    }
`;
const PageTitle = ({title, desc}) => {
    return (
        <>
            <Title>{title}<Desc>{desc}</Desc></Title>
        </>
    );
};

export default PageTitle;
